module.exports = __webpack_public_path__ + "static/img/aboutBanner.7fc01ba2.png";